export default "__VITE_ASSET__C_SbJClE__"